module.exports = __webpack_public_path__ + "fb99c931784724bc31bb25abaf2387d0.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Avdelare/img/mil_mob_gray.gif
 ** module id = 458
 ** module chunks = 0
 **/